// extracted by mini-css-extract-plugin
module.exports = {"jobRankingSummary":"jobRankingSummary","jobRankingSummary__updatedDate":"jobRankingSummary__updatedDate"};